/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".emptySpan[_ngcontent-%COMP%]{display:block;height:20px;width:70px;position:absolute;top:5px}"];
export { styles as styles };
